<template>
  <UploadIcon class="icon" width="37" />
  <div class="title" :class="{ compact: compact }">
    <span v-if="!compact">
      {{ t('drop_instruction') }}
      <button type="button" @click="$emit('browse')">{{ t('browse_file') }}</button>
    </span>
    <button v-else type="button" @click="$emit('browse')">Upload photo</button>
  </div>
  <div class="text" :class="{ compact: compact }">
    <div>{{ t('files_supported') }}: {{ accept }}</div>
    <div>
      {{ t('max_size') }}: <span>{{ maxSize }}</span>
    </div>
  </div>
</template>

<script setup>
import UploadIcon from 'app/assets/images/operatorDashboard/upload.svg?component'
import { useShared } from '@/helpers/vueHelpers.js'

defineProps({
  accept: String,
  maxSize: String,
  compact: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['browse'])

const { t } = useShared()
</script>

<style lang="scss" scoped>
$subtitle-line-height: 26px;

.icon {
  display: block;
  margin: auto;
}

.title {
  text-align: center;
  font-size: $text-xl;
  line-height: $subtitle-line-height;
  font-weight: $font-semibold;

  &.compact {
    font-size: $text-lg;
  }

  button {
    font-weight: $font-semibold;
    color: $brand-tertiary;
  }
}

.text {
  text-align: center;
  @include flex-column;
  align-items: center;
  gap: $spacing-3;
  color: $gray;
  line-height: $leading-snug;

  &.compact {
    gap: $spacing-1;
    font-size: $text-sm;
  }
}
</style>

<i18n lang="yaml">
en:
  drop_instruction: Drag and drop your file here or
  browse_file: browse file
  files_supported: Files supported
  max_size: Maximum file size
</i18n>
